import BaseEnumType from "../../common/base-enum-type";

const TennisTeamSide = Object.freeze({
    Home: new BaseEnumType("home", "Home"),
    Away: new BaseEnumType("away", "Away")
});

export default TennisTeamSide;
